/**
 * @generated SignedSource<<638a5cba9900618156e97b2a01557ec3>>
 * @relayHash e15a78ec619ae2b7476a646cfd8d1018
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1a90a8b35a0193c7cb72c385f9ea05b24fd71f15b06a8f679d7123bcacb4c4a3

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSetDefaultNavigationItemInput = {
  id: string;
  scopeId?: string | null | undefined;
};
export type useSetAsDefaultMutation$variables = {
  input: JiraSetDefaultNavigationItemInput;
};
export type useSetAsDefaultMutation$data = {
  readonly jira: {
    readonly setDefaultNavigationItem: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly newDefault: {
        readonly isDefault: boolean | null | undefined;
        readonly label: string | null | undefined;
      } | null | undefined;
      readonly previousDefault: {
        readonly isDefault: boolean | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useSetAsDefaultMutation = {
  response: useSetAsDefaultMutation$data;
  variables: useSetAsDefaultMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "label"
},
v4 = {
  "kind": "ScalarField",
  "name": "isDefault"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSetAsDefaultMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSetDefaultNavigationItemPayload",
            "kind": "LinkedField",
            "name": "setDefaultNavigationItem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "newDefault",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "previousDefault",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              },
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSetAsDefaultMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSetDefaultNavigationItemPayload",
            "kind": "LinkedField",
            "name": "setDefaultNavigationItem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "newDefault",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "previousDefault",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/)
                ]
              },
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1a90a8b35a0193c7cb72c385f9ea05b24fd71f15b06a8f679d7123bcacb4c4a3",
    "metadata": {},
    "name": "useSetAsDefaultMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e881b74009f0b5c207e9d80bf40f61bf";

export default node;
